<div *ngIf="groupData" class="drawer-group" [ngClass]="groupData.layout">
    <finder-component-header *ngIf="!isHeaderDataEmpty"
        [data]="groupData.headerData"
        [hrDecoration]="groupData.hrDecoration"
    ></finder-component-header>
    <div class="drawer-cards">
        <finder-campaign-drawer-card
            *ngFor="let drawer of groupData.drawerGroup; let index = index"
            [attr.id]="'card-' + drawer.id"
            [cardData]="drawer"
            [cardIndex]="index + 1"
            [groupId]="groupData.blockId"
            [showCaret]="activeGroup && selectedCard === index + 1"
        ></finder-campaign-drawer-card>
    </div>
    <finder-campaign-drawer-detail
        [groupId]="groupData.blockId"
        [allowReorder]="true"
    ></finder-campaign-drawer-detail>
</div>
